import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import { comics } from '@/mocks/comics';

const siteUrl = 'http://iitzgd.cn/';

const panelSetA = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%201%20of%20royal%20romance%2C%20elegant%20historical%20Korean%20palace%20scene%2C%20detailed%20character%20in%20traditional%20hanbok%2C%20speech%20bubbles%20with%20dialogue%2C%20vertical%20scroll%20format%2C%20professional%20webtoon%20style%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere&width=800&height=1100&seq=read-p101-1&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%202%20royal%20court%20drama%2C%20prince%20and%20princess%20confrontation%2C%20elegant%20palace%20interior%20background%2C%20emotional%20expressions%2C%20detailed%20webtoon%20art%2C%20dramatic%20composition%2C%20vertical%20reading%20layout&width=800&height=1100&seq=read-p101-2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%203%20romantic%20moment%20in%20garden%2C%20cherry%20blossom%20petals%20falling%2C%20soft%20lighting%2C%20intimate%20scene%20between%20two%20characters%2C%20beautiful%20webtoon%20illustration%2C%20emotional%20storytelling&width=800&height=1100&seq=read-p101-3&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%204%20dramatic%20confrontation%20scene%2C%20angry%20expression%2C%20dynamic%20composition%2C%20dark%20shadows%20and%20dramatic%20lighting%2C%20palace%20corridor%20background%2C%20professional%20webtoon%20art%20style&width=800&height=1100&seq=read-p101-4&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%205%20cliffhanger%20ending%2C%20mysterious%20silhouette%20appears%2C%20tense%20atmosphere%2C%20dark%20palace%20night%20scene%2C%20dramatic%20webtoon%20art%2C%20suspenseful%20composition%2C%20to%20be%20continued&width=800&height=1100&seq=read-p101-5&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%206%20court%20ladies%20gossip%20scene%2C%20colorful%20hanbok%20costumes%2C%20palace%20corridor%20with%20traditional%20architecture%2C%20expressive%20character%20art%2C%20detailed%20webtoon%20illustration%2C%20lively%20atmosphere&width=800&height=1100&seq=read-p101-6&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%207%20princess%20alone%20in%20moonlit%20courtyard%2C%20melancholic%20expression%2C%20beautiful%20night%20sky%20with%20full%20moon%2C%20traditional%20Korean%20architecture%2C%20poetic%20webtoon%20composition%2C%20emotional%20depth&width=800&height=1100&seq=read-p101-7&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%208%20surprise%20encounter%20in%20secret%20passage%2C%20shocked%20expressions%2C%20candlelit%20underground%20tunnel%2C%20mysterious%20atmosphere%2C%20dramatic%20webtoon%20cliffhanger%2C%20detailed%20illustration&width=800&height=1100&seq=read-p101-8&orientation=portrait',
];

const panelSetB = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%201%2C%20young%20hero%20entering%20magical%20school%20gates%2C%20grand%20castle%20architecture%2C%20floating%20crystals%2C%20wonder%20and%20awe%20expression%2C%20detailed%20webtoon%20illustration%2C%20cinematic%20magical%20atmosphere&width=800&height=1100&seq=read-p201-1&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%202%2C%20classroom%20scene%20with%20magic%20lesson%2C%20students%20casting%20spells%2C%20magical%20energy%20effects%2C%20dynamic%20composition%2C%20professional%20webtoon%20art%2C%20bright%20and%20vibrant&width=800&height=1100&seq=read-p201-2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%203%2C%20rival%20confrontation%20in%20training%20arena%2C%20clashing%20magic%20spells%2C%20intense%20battle%20pose%2C%20dramatic%20lighting%2C%20action%20webtoon%20composition&width=800&height=1100&seq=read-p201-3&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%204%2C%20library%20scene%20discovering%20ancient%20book%2C%20mysterious%20glowing%20text%2C%20dark%20academia%20aesthetic%2C%20detailed%20illustration%2C%20atmospheric%20lighting&width=800&height=1100&seq=read-p201-4&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%205%2C%20forbidden%20forest%20exploration%2C%20eerie%20atmosphere%2C%20shadow%20creatures%20lurking%2C%20suspenseful%20webtoon%20art%2C%20dark%20greens%20and%20mystical%20light&width=800&height=1100&seq=read-p201-5&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%206%2C%20friendship%20moment%20in%20dormitory%2C%20characters%20sharing%20meal%2C%20warm%20candlelight%2C%20cozy%20atmosphere%2C%20character%20development%2C%20detailed%20webtoon%20style&width=800&height=1100&seq=read-p201-6&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%207%2C%20hidden%20power%20awakening%2C%20glowing%20aura%20surrounding%20hero%2C%20shocked%20bystanders%2C%20epic%20revelation%20moment%2C%20dramatic%20webtoon%20composition&width=800&height=1100&seq=read-p201-7&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panel%20page%20fantasy%20academy%208%2C%20cliffhanger%20dark%20force%20approaching%20academy%2C%20ominous%20sky%2C%20hero%20readying%20for%20battle%2C%20epic%20scale%2C%20cinematic%20webtoon%20ending&width=800&height=1100&seq=read-p201-8&orientation=portrait',
];

const allPanelSets: Record<string, string[]> = {
  '1-1': panelSetA,
  '1-2': panelSetB,
};

export default function ReadPage() {
  const { comicId, chapterId } = useParams<{ comicId: string; chapterId: string }>();
  const comic = comics.find((c) => c.id === Number(comicId));
  const chNum = Number(chapterId) || 1;
  const [loading, setLoading] = useState(true);

  const panelKey = `${comicId}-${chapterId}`;
  const panels = allPanelSets[panelKey] || (Number(comicId) === 1 ? panelSetA : panelSetB);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [comicId, chapterId]);

  if (!comic) {
    return (
      <>
        <Navbar />
        <div className="pt-20 pb-10 text-center">
          <p className="text-foreground-500">漫画不存在</p>
        </div>
        <Footer />
      </>
    );
  }

  const prevChapter = chNum > 1 ? chNum - 1 : null;
  const nextChapter = chNum < (comic.totalChapters || comic.updateChapter) ? chNum + 1 : null;
  const pageUrl = `${siteUrl}/read/${comicId}/${chapterId}`;

  const readSchema = [
    {
      '@context': 'https://schema.org',
      '@type': 'ComicStory',
      name: `${comic.title} 第${chNum}话`,
      url: pageUrl,
      description: `${comic.title}第${chNum}话 - 免费下拉式阅读，无删减完整版。`,
      author: { '@type': 'Person', name: comic.author },
      isPartOf: { '@type': 'ComicSeries', name: comic.title, url: `${siteUrl}/comic/${comic.id}` },
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: comic.title, item: `${siteUrl}/comic/${comic.id}` },
        { '@type': 'ListItem', position: 3, name: `第${chNum}话`, item: pageUrl },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title={`${comic.title} 第${chNum}话_免费下拉式阅读_韩漫大全`}
        description={`${comic.title}第${chNum}话免费下拉式阅读，无删减完整版。韩漫大全提供流畅的下拉式漫画阅读体验。`}
        keywords={`${comic.title},第${chNum}话,韩国漫画,韩漫,免费阅读,下拉式观看`}
        canonicalUrl={pageUrl}
        ogImage={comic.coverImageLarge}
        schemaData={readSchema}
      />
      <Navbar />
      <main>
        <div className="pt-16">
          <div className="bg-background-50 border-b border-background-200 sticky top-16 z-30">
            <div className="mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Link to={`/comic/${comic.id}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  <i className="ri-arrow-left-line mr-1"></i>返回详情
                </Link>
                <span className="text-sm text-foreground-300">|</span>
                <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{comic.title}</span>
                <span className="text-sm text-foreground-500">第{chNum}话</span>
              </div>
              <div className="flex items-center gap-2">
                {prevChapter && (
                  <Link
                    to={`/read/${comic.id}/${prevChapter}`}
                    className="px-3 py-1.5 rounded-full bg-background-100 text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-arrow-left-s-line mr-1"></i>上一话
                  </Link>
                )}
                {nextChapter && (
                  <Link
                    to={`/read/${comic.id}/${nextChapter}`}
                    className="px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    下一话<i className="ri-arrow-right-s-line ml-1"></i>
                  </Link>
                )}
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-col items-center justify-center py-20 gap-3">
              <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-sm text-foreground-500">加载中...</p>
            </div>
          ) : (
            <div className="mx-auto max-w-[800px] px-4 py-6">
              <div className="space-y-0">
                {panels.map((src, index) => (
                  <div key={index} className="w-full">
                    <img
                      src={src}
                      alt={`${comic.title} 第${chNum}话 - 第${index + 1}页`}
                      title={`${comic.title} 第${chNum}话`}
                      className="w-full h-auto"
                      loading={index < 3 ? 'eager' : 'lazy'}
                    />
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-between mt-10 py-6 border-t border-background-200">
                {prevChapter ? (
                  <Link
                    to={`/read/${comic.id}/${prevChapter}`}
                    className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-arrow-left-s-line"></i>上一话
                  </Link>
                ) : (
                  <div></div>
                )}
                <Link
                  to={`/comic/${comic.id}`}
                  className="px-5 py-2.5 rounded-full bg-background-100 text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  章节目录
                </Link>
                {nextChapter ? (
                  <Link
                    to={`/read/${comic.id}/${nextChapter}`}
                    className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    下一话<i className="ri-arrow-right-s-line"></i>
                  </Link>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}